import _ from 'lodash';

// TODO Make this private to the backend.

export function makePermissionDbHelpers(system, permissionTypeEnum) {
  function getPermissionName(id) {
    return _.findKey(permissionTypeEnum, _.partial(_.isEqual, id));
  }
  function getPermissionId(permissionType) {
    return permissionTypeEnum[permissionType];
  }
  function serializePermissions(dbPermissions) {
    // this logic should be moved to some sort of serializer

    const permissions = {};
    for (const dbPermission of dbPermissions ?? []) {
      const permissionName = getPermissionName(dbPermission.permission);
      if (typeof permissionName === 'string') {
        for (const a of system.actionTypes) {
          if (dbPermission[a]) {
            _.set(permissions, [permissionName, a], true);
          }
        }
      }
    }
    return permissions;
  }
  return {
    permissionTypeEnum,
    getPermissionName,
    getPermissionId,
    serializePermissions
  };
}